module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/190/assets/images/792871a6e9a3fdad7a5a71bfe9219010.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_close.svg
// module id = W3S+
// module chunks = 1